import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";
import {VehicleType} from "../../../commons/types/vehicle.type";

export class VehiclesMultiSelectComponent implements IController {

  selectedIds: any;
  ngPlaceholder: any;
  isDisabled: any;
  vehicleTypes: VehicleType[];
  onChange: Function;

  private vehiclesRef: any;
  public selectedVehicles: any;
  public selectedText: any;

  /* @ngInject */
  constructor(private $mdPanel, private $vehicles, private $element) {
    this.vehiclesRef = this.$vehicles()
  }

  $onInit() {
    this._setSelectedVehicles();
  };

  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()){
      this._setSelectedVehicles();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdsRef = this.selectedIds || [];
    const ngPlaceholderRef = this.ngPlaceholder;
    const vehicleTypesRef = this.vehicleTypes;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-multi-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-ids="ctrl.selectedIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'query-map="ctrl.queryMapRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-multi-select-filter-panel>',
      controller: function () {
        this.typeRef = 'vehicles';
        this.selectedIdsRef = selectedIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.queryMapRef = {
          vehicleTypes: vehicleTypesRef,
        }
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedIds) => {
        if (selectedIds === 'clickOutsideToClose' || selectedIds === 'escapeToClose') {
          selectedIds = selectedIdsRef;
        }

        this.onChange({ids: selectedIds});
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({ids: [], logisticsVehicles: []});
  }

  private _setSelectedVehicles() {
    if (!!this.selectedIds) {
      this.vehiclesRef.$asyncValues(this.selectedIds)
        .then((vehicles) => {
          this.selectedVehicles = _.orderBy(vehicles, ['name'], ['asc']);
          this._setSelectedText();
        });
    }else {
      this.selectedVehicles = [];
      this._setSelectedText();
    }
  }

  private _setSelectedText() {
    let string = '';
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext("2d");

    _.forEach(this.selectedVehicles, (b, i) => {
      string += b.name;
      if ((i + 1) < this.selectedVehicles.length) {
        string += ', '
      }
    });

    var stringWidth = ctx.measureText(string).width;
    if (this.$element[0]?.clientWidth && (stringWidth + 80) >= (this.$element[0].clientWidth - 30)) {
      string = this.selectedVehicles[0].name + ` +${this.selectedVehicles.length - 1}`
    }
    this.selectedText = string;
  }


}

angular
  .module('bringoz.admin.vehicles')
  .component('vehiclesMultiSelect', {
    bindings: {
      selectedIds: '<?',
      ngPlaceholder: '@?',
      isDisabled: '<?',
      vehicleTypes: '<?',
      onChange: '&'
    },
    template: require('./vehicles-multi-select.html').default,
    controller: VehiclesMultiSelectComponent
  });
